<template>
  <div class="publicMain">
    <el-row class="leftClass">
      <el-col :span="6">
        <label style="width: 100px;">{{ '表名称' }}：</label>
        <el-input v-model="queryForm.bmc" clearable size="small" style="width: 70%;"></el-input>
      </el-col>
      <el-col :span="6">
        <label style="width: 100px;">{{ '表描述' }}：</label>
        <el-input v-model="queryForm.bms" clearable size="small" style="width: 70%;"></el-input>
      </el-col>
      <el-col :span="6">
        <label style="width: 100px;">{{ '表分类' }}：</label>
        <el-select v-model="queryForm.bfl" clearable size="small" style="width: 70%;">
          <el-option
            v-for="item in optionsBfl"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="rightClass" style="margin: 10px 0;">
      <el-col :span="12" style="text-align: left;">
        <el-button size="mini" type="primary" @click="openDialog('add')">{{ $t('common.addedBtn') }}</el-button>
        <el-button size="mini" :disabled="editDisabled" type="success" @click="openDialog('edit', multipleSelection[0])">{{ $t('common.editBtn') }}</el-button>
        <el-button size="mini" :disabled="delDisabled" type="danger" @click="openDialog('del', multipleSelection)">{{ $t('common.deleteBtn') }}</el-button>
      </el-col>
      <el-col :span="12" style="text-align: right;">
        <el-button size="mini" type="primary" @click="getGlzdList('query')">{{ $t('common.searchBtn') }}</el-button>
        <el-button size="mini" @click="resetSearch('reset')">{{ $t('common.resetBtn') }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" border style="width: 100%; font-size: 12px;"
        :header-cell-style="{background:'#f5f7fa', color:'#909399'}"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50px" align="center"></el-table-column>
        <el-table-column prop="bmc" :label="'表名称'" align="center"></el-table-column>
        <el-table-column prop="bms" :label="'表描述'" align="center"></el-table-column>
        <el-table-column :label="'表分类'" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.bfl=='GZ'">{{ '工资' }}</span>
            <span v-if="scope.row.bfl=='YS'">{{ '预算' }}</span>
            <span v-if="scope.row.bfl=='ZW'">{{ '账务' }}</span>
            <span v-if="scope.row.bfl=='GS'">{{ '个税' }}</span>
            <span v-if="scope.row.bfl=='SF'">{{ '收费' }}</span>
            <span v-if="scope.row.bfl=='WB'">{{ '网报' }}</span>
            <span v-if="scope.row.bfl=='SB'">{{ '申报' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="glmc" :label="'归类名称'" align="center"></el-table-column>
        <el-table-column prop="gldm" :label="'归类代码'" align="center"></el-table-column>
        <el-table-column prop="sfqy" :label="'是否启用年度'" align="center" width="95px">
          <template slot-scope="scope">
            <el-tag type="info" size="mini" effect="dark" v-if="scope.row.sfqy==0">{{ '否' }}</el-tag>
            <el-tag type="success" size="mini" effect="dark" v-if="scope.row.sfqy==1">{{ '是' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="updator" :label="$t('common.updator')" align="center"></el-table-column>
        <el-table-column prop="updateAt" :label="$t('common.updateAt')" width="140px" align="center"></el-table-column>
        <el-table-column prop="creator" :label="$t('common.creator')" align="center"></el-table-column>
        <el-table-column prop="createAt" :label="$t('common.createAt')" width="140px" align="center"></el-table-column>
        <el-table-column :label="$t('common.operation')" width="100px" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog('edit', scope.row)">{{ $t('common.editBtn') }}</el-button>
            <el-button type="text" @click="openDialog('del', [scope.row])">{{ $t('common.deleteBtn') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <!-- 分页组件 -->
      <Pagination :currentPage="currentPage" :total="total" :limit="limit" :small="true" :pageSizes="$store.state.pageSizes"
        @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" />
    </el-row>

    <!-- 归类信息模态框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="true" @close="handleClose">
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card style="padding: 0 20% 0 20%">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
          :validate-on-rule-change="false" size="small">
          <el-form-item :label="'表名称'" prop="bmc" class="formClass">
            <el-select v-model="ruleForm.bmc" :disabled="disabledFlg" default-first-option
              :placeholder="'请选择表名称'" style="width: 100%;" filterable clearable
              @change="bmcChange(ruleForm.bmc)">
              <el-option
                v-for="item in optionsTabName"
                :key="item.value"
                :label="item.value"
                :value="item.value">
                <span style="float: left">{{ item.value }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="'表描述'" prop="bms">
            <el-input v-model="ruleForm.bms" maxlength="50" show-word-limit :placeholder="'请输入表描述'"></el-input>
          </el-form-item>
          <el-form-item :label="'归类名称'" prop="glmc" class="formClass">
            <el-select v-model="ruleForm.glmc" :disabled="gllFlg" default-first-option
              :placeholder="'请选择归类名称列'" style="width: 100%;" filterable clearable>
              <el-option
                v-for="item in optionsCol"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                <span style="float: left">{{ item.value }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="'归类代码'" prop="gldm" class="formClass">
            <el-select v-model="ruleForm.gldm" :disabled="gllFlg" default-first-option
              :placeholder="'请选择归类代码列'" style="width: 100%;" filterable clearable>
              <el-option
                v-for="item in optionsCol"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                <span style="float: left">{{ item.value }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="'表分类'" prop="bfl">
            <el-select v-model="ruleForm.bfl" default-first-option :placeholder="'请选择表分类'" style="width: 100%;">
              <el-option
                v-for="item in optionsBfl"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="'是否启用年度'" prop="sfqy">
            <el-switch class="isWebClass"
              v-model="ruleForm.sfqy"
              active-value="1"
              inactive-value="0"
              :active-text="$t('common.yes')"
              :inactive-text="$t('common.no')">
            </el-switch>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">{{ $t('common.cancelBtn') }}</el-button>
        <el-button type="primary" size="small" @click="submitForm('ruleForm')">{{ $t('common.saveBtn') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'glzd',
  computed: {
    rules() {    // 模态框数据校验规则
      return {
        bmc: [{ required: true, message: "请选择表名称", trigger: "change" }],
        bms: [{ required: true, message: "请输入表描述", trigger: "blur" }],
        glmc: [{ required: true, message: "请选择归类列", trigger: "change" }],
        gldm: [{ required: true, message: "请选择归类列", trigger: "change" }],
        bfl: [{ required: true, message: "请选择表分类", trigger: "change" }],
      }
    },
    gllFlg() {
      return this.ruleForm.bmc == '' ? true : false
    }
  },
  data() {
    return {
      queryForm: {    // 查询条件
        uname: "",
        suid: "",
        isok: "",
      },
      ruleForm: {
        bmc: "",
        bms: "",
        bfl: "",
        glmc: "",
        gldm: "",
        sfqy: "0"
      },
      tableData: [],
      optionsBfl: [],    // 表分类
      optionsTabName: [],    // 表名称选项
      optionsCol: [],    // 表列选项
      editDisabled: true,    // 编辑按钮状态
      delDisabled: true,    // 删除按钮状态
      multipleSelection: [],    // 表格选中行
      currentPage: 1,    // 页码
      limit: this.$store.state.dataDisplayNum,    // 分页显示条数
      total: 0,    // 列表数据量
      pageSizes: this.$store.state.pageSizes,    // 分页显示可选择条数
      dialogFormVisible: false,
      dialogTitle: '',    // 模态框标题
      dialogTitleIcon: '',    // 模态框标题图标
      disabledFlg: false,    // 输入框是否可编辑
      saveFlg: '',    // 保存操作区分
      // gllFlg: true,    // 归类列标记FLG
    };
  },
  methods: {
    /** 获取归类字典信息 */
    getGlzdList(flg) {
      let _this = this;
      _this.tableData = [];
      if(flg == 'query' || flg == 'reset' || flg == 'add' || flg == 'edit' || flg == 'del') {
        _this.queryForm.currentPage = 1;
        _this.queryForm.limit = _this.$store.state.dataDisplayNum;
        _this.currentPage = 1;
      } else {
        _this.queryForm.currentPage = _this.currentPage;
        _this.queryForm.limit = _this.limit;
      }
      _this.tabLoading = true;    // 关闭请求时的loading层
      _this.$ajax.post("/api/xtglGlzd/getGlzdList", _this.queryForm).then((res) => {
        _this.tabLoading = false;    // 关闭请求时的loading层
        if(res.data.code == '200') {
          if(res.data.data.length > 0) {
            _this.total = res.data.data[0].tableCount;
          } else {
            _this.total = 0;
          }
          _this.tableData = res.data.data;
          // _this.$nextTick(() => {

            // for(let i = 0; i < _this.tableData.length; i++) {
            //   let tmpGll = ''
            //   let tmpdata = JSON.parse(_this.tableData[i].gll)
            //   for(let j = 0; j < tmpdata.length; j++) {
            //     // tmpGll += (j == 0 || tmpdata[j].label == '' ? '' : ',') + tmpdata[j].label
            //     tmpGll += (j == 0 || tmpdata[j].value == '' ? '' : ',') + tmpdata[j].value
            //   }
            //   _this.tableData[i].tmpGll = tmpGll
            // }
          // })
        }
      }).catch((error) => {
        _this.tabLoading = false;    // 关闭请求时的loading层
      })
    },
    /** 打开模态框 */
    openDialog(flg, row) {
      if(flg == 'add') {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = '新增归类字典';
          this.dialogTitleIcon = 'el-icon-document-add';
          this.disabledFlg = false;
        })
      } else if(flg == 'edit') {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = '编辑归类字典';
          this.dialogTitleIcon = 'el-icon-edit-outline';
          this.ruleForm.id = row.id;
          this.ruleForm.bmc = row.bmc;
          this.ruleForm.bms = row.bms;
          this.ruleForm.bfl = row.bfl;
          // let tmpArr = JSON.parse(row.gll)
          // for(let tmp in tmpArr) {
          //   tmpArr[tmp] = (tmpArr[tmp].label == '' ? 'null' : tmpArr[tmp].label) + '|' + tmpArr[tmp].value
          // }
          // this.ruleForm.gll = row.tmpArr;
          this.ruleForm.glmc = row.glmc;
          this.ruleForm.gldm = row.gldm;
          this.ruleForm.sfqy = row.sfqy;
          this.disabledFlg = true;
          // this.gllFlg = false
          this.getTableCol(this.ruleForm.bmc)
        })
      } else if(flg == 'del') {
        let tmpArr = [];
        for(let tmp of row) {
          tmpArr.push(tmp.id);
        }
        this.delGlzdInfo(tmpArr);
      }
      this.saveFlg = flg;
    },
    /** 保存模态框数据 */
    submitForm(formName) {
      let _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          // let tmpData = []
          // for(let tmp of _this.ruleForm.gll) {
          //   let tmpLabel = ''
          //   let tmpValue = ''
          //   if(!(tmp.split('|')[0] == 'null' || tmp.split('|')[0] == '')) {
          //     tmpLabel = tmp.split('|')[0]
          //   }
          //   tmpValue = tmp.split('|')[1]
          //   tmpData.push({ label: tmpLabel, value: tmpValue })
          // }
          // _this.ruleForm.gll = JSON.stringify(tmpData)
          if(_this.saveFlg === 'add') {
            _this.addGlzdInfo();
          } else if(_this.saveFlg === 'edit') {
            _this.editGlzdInfo();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /** 添加归类字典 */
    addGlzdInfo() {
      let _this = this;
      _this.$ajax.post('/api/xtglGlzd/addGlzdInfo', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        if(res.data.code == '200') {
          _this.getGlzdList('add');
          _this.$message.success('归类信息，添加成功');
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    /** 添加归类字典 */
    editGlzdInfo() {
      let _this = this;
      _this.$ajax.post('/api/xtglGlzd/editGlzdInfo', _this.ruleForm).then((res) => {
        _this.dialogFormVisible = false;
        if(res.data.code == '200') {
          _this.getGlzdList('edit');
          _this.$message.success('归类信息，编辑成功');
        }
      }).catch((error) => {
        _this.dialogFormVisible = false;
      });
    },
    /** 删除归类字典 */
    delGlzdInfo(dataArr) {
      let _this = this;
      _this.$confirm(_this.$t('common.deleteContent'), _this.$t('common.deleteTitle'), {
        distinguishCancelAndClose: true,
        confirmButtonText: _this.$t('common.confirmBtn'),
        cancelButtonText: _this.$t('common.cancelBtn')
      }).then(res1 => {
        _this.$ajax.post("/api/xtglGlzd/delGlzdInfo", dataArr).then((res) => {
          let msgCode = res.status;
          if(res.status == '200') {
            if(res.data.code == '200') {
              _this.getGlzdList('del');
              _this.$message.success("归类信息，删除成功");
            }
          }
        })
      }).catch(action => {
        // this.$message.info({
        //   message: action === 'cancel' ? '放弃保存并离开页面' : '停留在当前页面'
        // })
      });
    },
    /** 获取当前数据库用户所有表名称选项 */
    getTablesName() {
      let _this = this
      _this.$ajax.post("/api/xtglGlzd/getTablesName").then((res) => {
        if(res.data.code == '200') {
          _this.optionsTabName = []
          for(let tmpdata of res.data.data) {
            _this.optionsTabName.push({
              label: tmpdata.bms,
              value: tmpdata.bmc,
            })
          }
        }
      })
    },
    /** 获取选择表的列信息 */
    async getTableCol(data) {
      let _this = this
      await _this.$ajax.post("/api/xtglGlzd/getTableCol", { tabName: data }).then((res) => {
        if(res.data.code == '200') {
          _this.optionsCol = []
          for(let tmpdata of res.data.data) {
            _this.optionsCol.push({
              label: tmpdata.lms,
              value: tmpdata.lmc,
            })
          }
          // _this.gllFlg = false
        }
      })
    },
    async bmcChange(data) {
      let _this = this;
      _this.ruleForm.glmc = ""
      _this.ruleForm.gldm = ""
      let aaa = _this.ruleForm.bms
      // _this.gllFlg = false
      if(data == "") {
        _this.ruleForm.bms = ''
        // _this.gllFlg = true
      } else {
        for(let tmp of _this.optionsTabName) {
          tmp.value == _this.ruleForm.bmc ? _this.ruleForm.bms = tmp.label : '';
        }
      }
      await _this.getTableCol(_this.ruleForm.bmc)
    },
    /** 重置操作 */
    resetSearch(flg) {
      this.queryForm.bms = "";
      this.queryForm.bmc = "";
      this.queryForm.bfl = "";
      this.getGlzdList(flg);
    },
    /** 弹出层关闭事件 */
    handleClose(done) {
      this.$refs['ruleForm'].resetFields();
      // this.gllFlg = true
      // this.ruleForm.glmc = ""
      // this.ruleForm.gldm = ""
    },
    /** 表格数据选中事件 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if(this.multipleSelection.length == 1) {
        this.editDisabled = false;
      } else {
        this.editDisabled = true;
      }
      if(this.multipleSelection.length > 0) {
        this.delDisabled = false;
      } else {
        this.delDisabled = true;
      }
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.getGlzdList();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.getGlzdList();
    },
  },
  mounted() {
    this.getTablesName();
    this.getGlzdList();
    this.$requestUtil.getCodeInfoById(['NORMAL_CODE_TABLE_CATEGORY']).then(tmpResult => {
      if(Object.keys(tmpResult).length > 0) {
        // 表分类
        let bflCodeList = tmpResult["NORMAL_CODE_TABLE_CATEGORY"];
        for(let tmp of bflCodeList) {
          this.optionsBfl.push({
            label: tmp.name[this.$i18n.locale],
            value: tmp.code,
          });
        }
      }
    });
  },

}
</script>

<style lang="scss" scoped>
/* switch按钮样式 */
::v-deep .isWebClass {
  .el-switch__label--left {
    position: relative;
    left: 37px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__core{
    width: 50px !important;
  }
  .el-switch__label--right {
    position: relative;
    right: 37px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
</style>